module.exports = __webpack_public_path__ + "static/queens-cover-image-ea48d7c8ebc80f5bbe3121cff75c623d.jpg";